import { SxStyles } from '../../../../../../types';
import theme from '../../../../../../theme';
import { getResponsiveSize } from '../../../../../../utils';

export const UploadedStyle: SxStyles = {
  uploadedContainer: {
    overflow: 'auto',
    overflowX: 'hidden',
    width: '100%',
    padding: 0,
    margin: 0,
    position: 'relative',
    mr: getResponsiveSize(10),
    p: getResponsiveSize(20),

    '& .uploaded-list': {
      width: '100%',

      '& .item': {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: theme.palette.neutral?.grey8,
        mb: 1,
        padding: 1,
        borderRadius: 2,

        '&:hover': {
          backgroundColor: theme.palette.myPrimary?.lightBlue50,
          cursor: 'pointer',
        },

        '& .item-text': {
          textTransform: 'capitalize',
          color: theme.palette.neutral?.greyRGBA80,
          fontFamily: theme.typography.mainFontFamily,
          fontSize: getResponsiveSize(15),
          fontWeight: '400',
        },

        '& .buttons-container': {
          display: 'flex',
          alignItems: 'center',

          '& .expiration-container': {
            pr: 1,

            '& .expiration': {
              fontFamily: theme.typography.mainFontFamily,
            },
            '& .expiration-enough': {
              color: theme.palette.myPrimary?.lightBlue100,
              fontFamily: theme.typography.mainFontFamily,
            },
            '& .expiration-not-enough': {
              color: theme.palette.neutral?.error,
              fontFamily: theme.typography.mainFontFamily,
            },
          },

          '& .select-button': {
            transition: 'color 0.1s ease-in-out',

            '&:hover': {
              color: theme.palette.myPrimary?.lightBlue100,
            },
            '& .select-icon': {
              transition: 'color 0.1s ease-in-out',

              '&:hover': {
                color: theme.palette.neutral?.grey8,
                backgroundColor: theme.palette.myPrimary?.lightBlue100,
                borderRadius: '5px',
              },
            },
          },
          '& .remove-button': {
            transition: 'color 0.1s ease-in-out',

            '&:hover': {
              color: theme.palette.myPrimary?.lightBlue100, // Change the color on hover
            },
            '& .remove-icon': {
              transition: 'color 0.1s ease-in-out',

              '&:hover': {
                color: theme.palette.neutral?.greyRGBA80,
                // backgroundColor: theme.palette.myPrimary?.lightBlue100,
                borderRadius: '5px',
                outline: `1px solid ${theme.palette.neutral?.greyRGBA80}`,
              },
            },
          },
        },
      },
    },
    '&::-webkit-scrollbar': {
      width: 4,
    },
    '&::-webkit-scrollbar-track': {
      webkitBorderRadius: '100px',
      borderRadius: '100px',
      m: getResponsiveSize(10),
    },
    '&::-webkit-scrollbar-thumb': {
      webkitBorderRadius: '100px',
      borderRadius: '100px',
      background: theme.palette.neutral?.grey8,
    },
  },
};
